var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 90,
    viewBox: "0 0 77 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 82.714L3.16746 89L29.8273 85.0987L41.5317 72.744L39.7977 66.4583L41.7485 48.6849L48.2509 36.7638L57.7879 49.1184L63.6401 51.0692L66.0243 70.1431L75.778 69.0593L71.8765 49.9854L53.2362 33.2958L51.0687 16.3894L45.4332 17.6899L45.8667 1L7.9357 5.11807L7.5022 74.4778L1 82.714Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi);
export default __webpack_public_path__ + "static/media/RI.94cd9626c17edef2c9b18c16f687d052.svg";
export { ForwardRef as ReactComponent };